import type { ComponentProps } from "react";
import { Link } from "react-router";

import { cn } from "@/utils/tailwind";

import { Logo } from "./logo";

interface LogoWithTitleProps extends Omit<ComponentProps<typeof Link>, "to"> {
  linkTo?: string;
}

// Render the same compact identity in public, auth, and product shells.
export function LogoWithTitle({
  className,
  linkTo,
  ...props
}: LogoWithTitleProps) {
  const content = (
    <>
      <Logo className="size-7" />
      <span className="font-serif text-lg leading-none font-semibold tracking-tight">
        {publicEnv.siteTitle}
      </span>
    </>
  );
  const baseClassName = cn(
    "focus-visible:ring-ring/50 flex w-fit items-center gap-2.5 rounded-md outline-none focus-visible:ring-2",
    className,
  );

  return linkTo ? (
    <Link className={baseClassName} to={linkTo} {...props}>
      {content}
    </Link>
  ) : (
    <div className={baseClassName}>{content}</div>
  );
}
